import styled, { css } from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import styles
import { customMinResponsive, flex, size } from 'components/styles';

export const SliderWrapper = styled.div`
	position: relative;
	width: 100%;
	margin: 0 auto;

	${customMinResponsive(
		size.semi,
		css`
			width: 86rem;
		`
	)}

	${customMinResponsive(
		1200,
		css`
			width: 116rem;
		`
	)}

	${customMinResponsive(
		1650,
		css`
			width: 155rem;
		`
	)}
`;

export const Slider = styled(Swiper)<{ isLastSlide: boolean; padding: boolean }>`
	${flex()}
	margin: 0 auto;
	padding: 3.2rem 0;
	width: 100%;

	${({ padding }) =>
		!padding &&
		css`
			padding: 0;
			margin: auto !important;
		`}

	&::after {
		content: '';
		background: linear-gradient(
			90deg,
			${({ isLastSlide }) => (isLastSlide ? '#060a0f 0%, rgba(0, 0, 0, 0) 10%' : 'rgba(0, 0, 0, 0) 90%, #060a0f 100%')}
		);
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 10;
		pointer-events: none;

		${customMinResponsive(
			size.semi,
			css`
				display: none;
			`
		)}
	}

	${customMinResponsive(
		size.semi,
		css`
			margin: 1.6rem auto;
			width: 70rem;
		`
	)}

	${customMinResponsive(
		1200,
		css`
			margin: 1.6rem auto;
			width: 100rem;
		`
	)}

	${customMinResponsive(
		1650,
		css`
			margin: 3.2rem auto;
			width: 132rem;
		`
	)}
`;

export const Slide = styled(SwiperSlide)`
	height: auto;
`;

export const ArrowButton = styled.button`
	${flex()}
	display: none;
	position: absolute;
	z-index: 2;
	top: 50%;
	transform: translateY(-50%);
	width: 5rem;
	height: 5rem;
	border-radius: 50%;
	transition: all ease-in-out 0.2s;
	cursor: pointer;
	background: radial-gradient(
			157.86% 58.75% at 30.18% 5.11%,
			rgba(255, 255, 255, 0.2) 0%,
			rgba(155, 155, 155, 0.2) 36.68%,
			rgba(113, 112, 112, 0.2) 64.6%,
			rgba(78, 78, 78, 0.2) 100%
		),
		rgba(0, 0, 0, 0.3);
	border: 1px solid rgba(224, 224, 224, 0.3);

	&.arrow__next {
		right: 0;
	}

	&.arrow__prev {
		left: 0;
	}

	&:disabled {
		opacity: 0;
		visibility: hidden;
	}

	svg {
		transition: transform ease-in-out 0.2s;
		polygon {
			fill: ${({ theme: { configurator } }) => configurator.color.primary};
		}
	}

	&:hover {
		border: 1px solid rgba(224, 224, 224, 0.8);
		box-shadow: 0 0 8px rgba(224, 224, 224, 0.8);

		svg {
			transform: scale(1.2);
		}
	}

	&:active {
		box-shadow: none;

		svg {
			transform: scale(1.1);
		}
	}

	${customMinResponsive(
		size.semi,
		css`
			display: flex;
		`
	)}

	${customMinResponsive(
		size.large,
		css`
			width: 5.8rem;
			height: 5.8rem;
		`
	)}
`;
